




































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { user } from '@/modules/shared/shared/store/namespaces';
import { UPDATE_USER } from '@/modules/users/store/user.actions';
import { GET_USER_CONTACT } from '@/modules/users/store/user.getters';
import { Contact } from '@/modules/contacts/shared/domain/contact';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
@Component({
    name: 'activate-user',
    components: { BaseModal },
})
export default class ActivateUser extends Vue {
    @Prop({ required: false })
    contactToModify!: {
        userId: number;
        email: string;
        name: string;
        lastName: string;
        ci: string;
        contactId: number;
        customerId: number;
        status: number;
    };

    @Prop({ required: true, type: String })
    activationMode!: string;

    $refs!: {
        modal: any;
    };

    dialog: boolean = false;

    isLoading: boolean = false;

    get userStatuses() {
        let userStatuses: {
            id: number;
            name: string;
        }[] = [];
        return this.$store.state.userStatuses;
    }

    giveStatusId(name: string) {
        let status = this.userStatuses.filter(function(item: any) {
            return item.name.toUpperCase() === name.toUpperCase();
        });
        if (status[0]) {
            return status[0].id;
        } else {
            return 1;
        }
    }

    async transformContactToActivate() {
        const transformContact: {
            id: number;
            username: string;
            name: string;
            lastName: string;
            contactId: number;
            status: number;
            ci: string;
            applicant: {
                name: string;
                lastName: string;
                email: string;
                customer: {
                    name: string;
                };
            };
        } = {
            id: this.contactToModify.userId,
            username: this.contactToModify.email,
            name: this.contactToModify.name,
            lastName: this.contactToModify.lastName,
            contactId: this.contactToModify.contactId,
            ci: this.contactToModify.ci,
            status: this.activationMode === 'activate' ? 1 : 3,
            applicant: {
                name: this.USER_CONTACT.name,
                lastName: this.USER_CONTACT.lastName,
                email: this.USER_CONTACT.email,
                customer: {
                    name: this.USER_CONTACT.customer.name,
                },
            },
        };

        return await this.UPDATE_USER(transformContact);
    }

    displayContactNames(lastName: string, name: string) {
        if (lastName) {
            if (name) {
                return lastName + ', ' + name;
            } else {
                return lastName;
            }
        } else {
            if (name) {
                return name;
            } else {
                return 'No especificado';
            }
        }
    }

    @Emit('closeDialog')
    async submitContact() {
        this.isLoading = true;
        const r = await this.transformContactToActivate();
        this.isLoading = false;
        if (r) {
            EventBus.$emit(
                EventBusMessages.SHOW_SUCCESS,
                `El contacto ${this.contactToModify.name} ${
                    this.contactToModify.lastName
                } ha sido ${
                    this.activationMode === 'activate' ? 'activado' : 'inactivado'
                } exitosamente en el Portal`,
            );
            this.closeModal();
            return true;
        } else {
            EventBus.$emit(
                EventBusMessages.SHOW_ERROR,
                `Ha ocurrido un error, intente de nuevo más tarde`,
            );
            this.closeModal();
            return false;
        }
    }

    openModal() {
        this.$refs.modal.openModal();
    }

    closeModal() {
        this.$refs.modal.closeModal();
    }

    @user.Getter(GET_USER_CONTACT) USER_CONTACT!: Contact;
    @user.Action(UPDATE_USER) UPDATE_USER!: (user: {}) => Promise<boolean>;
}
